import { render, staticRenderFns } from "./Espaco.vue?vue&type=template&id=9cf0f504&scoped=true&"
import script from "./Espaco.vue?vue&type=script&lang=js&"
export * from "./Espaco.vue?vue&type=script&lang=js&"
import style0 from "./Espaco.vue?vue&type=style&index=0&id=9cf0f504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf0f504",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
